import { createAuthClient } from 'better-auth/react'

// baseURL defaults to the current origin; basePath matches the server mount
// (and the non-rewriting vite proxy rule) so cookies stay same-origin
export const authClient = createAuthClient({
  basePath: '/api/auth',
})

export const { signIn, signUp, signOut, useSession } = authClient
